import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchPosts(orderId) {
  return dispatch => {
    myGet(dispatch, servAddr + 'post', {
      params: {order_id: orderId}
    }).then((response) => {
      dispatch({type: "FETCH_POSTS", data:response.data.posts, order_id:orderId});
      dispatch({type: "FETCH_SRVCS", payload: response.data.srvcs});
      dispatch({type: "FETCH_SRVGS", payload: response.data.srvgs});
      dispatch({type: "FETCH_BSNSS", payload: response.data.bsnss});
      dispatch({type: "FETCH_COMPS", payload: response.data.comps});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function fetchPayments() {
  return dispatch => {
    myGet(dispatch, servAddr + 'payment').then((response) => {
      dispatch({type: "FETCH_ORDERS", payload: response.data.orders});
      dispatch({type: "FETCH_SRVCS", payload: response.data.srvcs});
      dispatch({type: "FETCH_COMPS", payload: response.data.comps});
      dispatch({type: "FETCH_POSTS_BATCH", payload:response.data.posts});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function changeOrderClient(orderId, oldId, newId){
  return dispatch => {
    myGet(dispatch, servAddr + 'post', {
      params: {order_id:orderId, old_id:oldId, new_id:newId}
    }).then((response) => {
      dispatch({type: "FETCH_POSTS", data:response.data.posts, order_id:orderId});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function changeOrderExecutor(orderId, oldId, newId){
  return dispatch => {
    myGet(dispatch, servAddr + 'post', {
      params: {order_id:orderId, old1_id:oldId, new1_id:newId}
    }).then((response) => {
      dispatch({type: "FETCH_POSTS", data:response.data.posts, order_id:orderId});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function changeOrderDate(orderId, oldDate, newDate){
  return dispatch => {
    myGet(dispatch, servAddr + 'post', {
      params: {order_id:orderId, old_date:oldDate, new_date:newDate}
    }).then((response) => {
      dispatch({type: "FETCH_POSTS", data:response.data.posts, order_id:orderId});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function filterPosts(order, filter) {
  return {
    type: 'FILTER_POSTS',
    order,
    filter
  };
}

export function sortPosts(order, sort) {
  return {
    type: 'SORT_POSTS',
    order,
    sort
  };
}

export function searchPosts(order, search) {
  return {
    type: 'SEARCH_POSTS',
    order,
    search
  };
}

export function editPost(post, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.post_post === 1 ? 'post' :
    'post_assigned';
  return dispatch => {
    myPost(dispatch, servAddr + model, {data: post}).then((response) => {
      if (post.post_id) {
        cb();
        dispatch({type: "EDIT_POST", payload: response.data.updated});
      }
      else {
        cb(null, response.data.id);
        dispatch({
          type: "CREATE_POST",
          payload: {
            ...post,
            post_price: parseFloat(("" + post.post_price).replace(',','.'),10),
            post_qntt: parseFloat(("" + post.post_qntt).replace(',','.'),10),
            post_id:response.data.id
          }
        });
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/postActions.js